import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';

function App() {
  const [message, setMessage] = useState('Загрузка...');

  useEffect(() => {
    fetch('/api/hello')
      .then(res => res.json())
      .then(data => setMessage(data.message))
      .catch(err => setMessage('Ошибка: ' + err.message));
  }, []);

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>🎭 Mafia-1</h1>
      <h2>{message}</h2>
      <p>Деплой через GitHub Actions!</p>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);